export const REQUEST_INVITEE_DATA = 'REQUEST_INVITEE_DATA';
export const INVITEE_DATA_RECEIVED = 'INVITEE_DATA_RECEIVED';